shadow$provide[275] = function(require,module,exports) {
Object.defineProperties(exports, {__esModule:{enumerable:true, value:true}, Clamp:{enumerable:true, get:function() {
  return Clamp;
}}});
var require$_DOT__SLASH_operator_DOT_js = require("./operator.js");
class Clamp extends require$_DOT__SLASH_operator_DOT_js.Operator {
  static initClass() {
    this.traits = ["node", "bind", "operator", "source", "index", "clamp"];
  }
  indexShader(shader) {
    shader.pipe(this.operator);
    return super.indexShader(shader);
  }
  sourceShader(shader) {
    shader.pipe(this.operator);
    return super.sourceShader(shader);
  }
  make() {
    super.make();
    if (this.bind.source == null) {
      return;
    }
    const uniforms = {clampLimit:this._attributes.make(this._types.vec4())};
    this.clampLimit = uniforms.clampLimit;
    const transform = this._shaders.shader();
    transform.pipe("clamp.position", uniforms);
    return this.operator = transform;
  }
  unmake() {
    return super.unmake();
  }
  resize() {
    if (this.bind.source != null) {
      const dims = this.bind.source.getActiveDimensions();
      this.clampLimit.value.set(dims.width - 1, dims.height - 1, dims.depth - 1, dims.items - 1);
    }
    return super.resize();
  }
  change(changed, touched, _init) {
    if (touched["operator"] || touched["clamp"]) {
      return this.rebuild();
    }
  }
}
Clamp.initClass();

};